<template>
  <div
    :class="
      `communication-form ${success ? 'success' : ''} ${isWx ? 'wx' : ''}`
    "
  >
    <div v-if="!success" class="tip view-box">
      <div class="tip-title">尊敬的万达广场商户：</div>
      <div class="tip-content">
        为更好的提升万达广场的商业环境和服务水平，我们对参加商户沟通会的所有商户进行回访，您填写的感受和意见将会帮助我们更好地改善万达广场现有的服务。感谢您的支持与配合！
      </div>
    </div>
    <div v-if="!success" class="store-info view-box">
      <store-card :info="storeInfo" class="bt-border" />
      <div class="field-details bt-border">
        <div class="label">会议时间</div>
        <div class="value">
          {{ info.meetDate }}
        </div>
      </div>
      <div class="field-details bt-border">
        <div class="label">参会人员</div>
        <div class="value">
          {{ info.businessmanName }}
        </div>
      </div>
      <div class="field-details bt-border">
        <div class="label">手机号</div>
        <div class="value">
          {{ info.businessmanTel }}
        </div>
      </div>
      <div class="field-details">
        <div class="label required">店铺是否参会</div>
        <div class="value">
          <radio-group v-model="isJoin" direction="horizontal">
            <radio name="1" icon-size="16px" checked-color="#FF6F00">是</radio>
            <radio name="0" icon-size="16px" checked-color="#FF6F00">否</radio>
          </radio-group>
        </div>
      </div>
    </div>
    <div v-if="!success" class="problem-list">
      <Problem v-for="item in problemList" :key="item.id" :option="item" />
    </div>
    <div v-if="!success" class="evaluate view-box">
      <div class="content">
        <div class="title">满意度评价</div>
        <ul class="evaluate-radio">
          <li
            v-for="item in evaluateList"
            :key="item.value"
            :class="value === item.value ? 'active' : ''"
            :data-idx="item.value"
            @click="value = item.value"
          >
            <img
              :src="
                require(`../../assets/img/communication/${item.value}${
                  value === item.value ? 'a' : ''
                }.png`)
              "
              class="img"
            />
            <span>{{ item.label }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="!success" class="handler">
      <SHButton :loading="loading" type="primary" size="large" @click="submit"
        >确认提交</SHButton
      >
    </div>
    <div class="success-res" v-if="success">
      <img
        :src="require(`../../assets/img/communication/success.png`)"
        class="img"
        alt=""
      />
      <span>提交成功</span>
      <SHButton v-if="!isWx" type="primary" size="large" @click="goBack"
        >返回</SHButton
      >
    </div>
  </div>
</template>

<script>
import 'vant/lib/radio-group/style';
import 'vant/lib/radio/style';

import { communicationApi } from '@api';
import bridge from '@utils/bridge';

export default {
  name: 'Form',

  mixins: [],

  components: {
    SHButton: () => import('@components/ShButton'),
    StoreCard: () => import('@/components/StoreCard'),
    Problem: () => import('./Problem'),
    RadioGroup: () => import('vant/lib/radio-group'),
    Radio: () => import('vant/lib/radio'),
  },

  props: {},

  data() {
    return {
      id: null,
      info: {},
      problemList: [],
      storeInfo: {
        storeCode: '',
      },
      isJoin: '',
      evaluateList: [
        { value: '1', label: '非常满意' },
        { value: '2', label: '比较满意' },
        { value: '3', label: '一般' },
        { value: '4', label: '不满意' },
        { value: '5', label: '非常不满意' },
      ],
      value: '',
      loading: false,
      success: false,
      isWx: false,
    };
  },

  computed: {
    submitParams() {
      return {
        id: this.id,
        isJoin: this.isJoin,
        questionList: this.problemList.map(item => {
          return {
            id: item.id,
            isSure: item.record.recordAccurate,
          };
        }),
        satisfaction: this.value,
      };
    },
  },

  watch: {},

  created() {
    this.initRouteData();
    this.initDetail();
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 获取路由参数
     */
    initRouteData() {
      this.id = this.$route.query.id;
      this.storeInfo.storeCode = this.$route.query.storeId;
      this.isWx = localStorage.getItem('wxAuth') === '1';
    },
    /**
     * 获取沟通会详情
     * @returns {Promise<*|VanToast>}
     */
    async initDetail() {
      const [err, res] = await this.$bsUtils.request(
        communicationApi.detail(this.id)
      );
      if (err) {
        return this.$bsUtils.toast(err.message || '沟通会获取失败！');
      } else if (res.isCommit === 1) {
        this.$router.replace({ name: 'communication-error' });
      }

      await this.dealDetailData(res);
    },
    /**
     * 处理返回详情信息
     * @param data
     * @returns {Promise<void>}
     */
    async dealDetailData(data) {
      this.info = data;

      this.problemList = this.info.questionList.map((item, idx) => {
        return {
          id: item.id,
          title: `问题${this.$bsUtils.toChinesNum(idx + 1)}`,
          record: {
            value: item.qaMemo,
            recordAccurate: '',
          },
        };
      });
    },
    /**
     * 提交沟通会表单
     * @returns {Promise<*|VanToast>}
     */
    async submit() {
      if (!this.isJoin) {
        return this.$bsUtils.toast('尚未填写是否参会！');
      }
      for (let item of this.problemList) {
        if (!item.record.recordAccurate) {
          return this.$bsUtils.toast(`${item.title}尚未确认！`);
        }
      }
      if (!this.value) {
        return this.$bsUtils.toast('尚未评价满意度！');
      }
      this.loading = true;
      try {
        await communicationApi.submit(this.submitParams);
        this.success = true;
        document.title = '提交完成';
        bridge.sendMessageToNative({
          id: this.id,
          status: true,
        });
      } catch (e) {
        this.$bsUtils.toast(e.message || '提交失败！');
      }
      this.loading = false;
    },
    goBack() {
      bridge.goBack({
        id: this.id,
        status: true,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.communication-form {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: #f4f4f4;
  //padding: 9px 10px;
  //box-sizing: border-box;

  &.success {
    background: #fff;
  }

  &.wx {
    box-sizing: border-box;
    padding-bottom: 70px;
  }

  & > div {
    width: 100%;
    box-sizing: border-box;
  }
  .bt-border {
    border-bottom: 1px solid #e4e4e4;
  }
  .field-details {
    width: 100%;
    height: 52px;
    display: flex;
    justify-content: space-between;
    .label {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-right: 8px;
      padding: 0;
      line-height: 52px;
      text-align: left;
    }
    .value {
      display: flex;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 52px;
      text-align: left;

      .img-list {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        img {
          width: 75px;
          height: 75px;
          margin-right: 5px;
          margin-bottom: 5px;
          border-radius: 4px;
        }
      }
    }
  }

  .store-info {
    padding: 8px 14px 5px;
    box-sizing: border-box;
  }

  .tip {
    padding: 16px 20px 14px;
    & > div {
      text-align: left;
    }
    .tip-title {
      font-size: 16px;
      font-weight: 500;
      color: #666666;
      line-height: 22px;
    }
    .tip-content {
      font-size: 12px;
      color: #a6a5a6;
      line-height: 20px;
      text-indent: 2em;
    }
  }
  .evaluate {
    width: 100%;
    .content {
      margin-bottom: 30px;
      padding: 16px 14px 14px;
      .title {
        width: 100%;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 16px;
        text-align: left;
      }
      .evaluate-radio {
        display: flex;
        width: 100%;
        margin: 16px 0 31px;
        li {
          flex: 1;
          display: flex;
          flex-direction: column;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
          align-items: center;
          .img {
            width: 40px;
            height: 40px;
            margin-bottom: 6px;
          }
          &.active {
            font-weight: 500;
            color: #333333;
          }
        }
      }
      & /deep/ .van-field {
        width: 100%;
        height: 100px;
        border-radius: 4px;
        margin-top: 16px;
        border: 1px solid #cccccc;
        padding: 4px 9px 8px 8px;
        .van-field__value {
          display: flex;
          flex-direction: column;
          .van-field__word-limit {
            margin-top: 0;
            color: #ccc;
          }
          .van-field__body {
            flex: 1;
            .van-field__control {
              width: 100%;
              height: 100% !important;
            }
          }
        }
      }
    }
  }

  .success-res {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 151px;
    padding: 0 14px;
    box-sizing: border-box;
    .img {
      width: 100px;
      height: 100px;
      margin-top: 18px;
    }
    & > span {
      margin-bottom: 60px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
    }
  }
}

/deep/ .van-radio__icon.van-radio__icon--round {
  i {
    background: #fff !important;
  }
}
/deep/ .van-radio__icon--checked {
  position: relative !important;
  & i:before {
    content: '';
    position: absolute !important;
    display: block;
    width: 8px;
    height: 8px;
    background: #FF6F00;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50px;
  }
}

.required {
  position: relative;
  &:before {
    content: '*';
    margin-right: 2px;
    color: #FF6F00;
  }
}
</style>
